'use strict';

+function ($) {

  basecoat.init.scrollspy = function () {
    // automatically activate scrollspy everywhere
    if ($('[data-scrollspy]').length > 0) {
      // bootstrap only allows one instance of scrollspy, so using an empty target makes this work on multile navs
      var navbarHeight = $('.site-header .navbar-fixed-top').height();
      $('body').scrollspy({
        target: '[data-scrollspy]',
        offset: navbarHeight + 10
      });
    }
  };

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/scrollspy.js
// module id = 16
// module chunks = 0